import { toast } from 'react-toastify'
import {
  getAllIncidentsInvitedUsers,
  getAllIncidentsLead,
  getAllSchoolMembers,
  getIncidentById,
  getNotesUsers,
} from '../../../api/lead/incidents'
import {
  incidentDataCountObj,
  incidentDataLogsResponse,
  incidentDataResponse,
  incidentDataResponseObject,
  invitedUsers,
  invitedUsersResponse,
  schoolMembers,
  schoolMembersResponse,
} from '../../../utils/types'

export const getIncidentData = async (
  sortBy: string,
  sortOrderValue: string,
  siverity: string
): Promise<incidentDataCountObj> => {
  const response = (await getAllIncidentsLead(
    // currentPage,
    sortBy,
    sortOrderValue,
    siverity
  )) as incidentDataResponse
  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getIncidentDataById = async (
  id: string,
  sId: string
): Promise<incidentDataLogsResponse> => {
  const response = (await getIncidentById(
    id,
    sId
  )) as incidentDataResponseObject

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}
export const getAllCandidates = async (): Promise<schoolMembers[]> => {
  const response = (await getAllSchoolMembers()) as schoolMembersResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getAllUsersInvited = async (
  id: string
): Promise<invitedUsers[]> => {
  const response = (await getAllIncidentsInvitedUsers(
    id
  )) as invitedUsersResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getAllInvolvedUsers = async (
  id: string
): Promise<invitedUsers[]> => {
  const response = (await getNotesUsers(id)) as invitedUsersResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}
